<script>
import Layout from "@/views/layouts/default";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";

import {
  required,
  email,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";


export default {
  name: "DriverForm",
  page: {
    title: "Tambah Driver",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, DatePicker },
  data() {
    return {
      title: "Tambah Driver",
      items: [
        {
          text: "Manajemen Armada",
        },
        {
          text: "Driver",
          href: "/driver"
        },
        {
          text: "Tambah",
          active: true
        },
      ],
      form: {
        name: "",
        email: "",
        phone: "",
        address: "",
        dob: "",
        gender: "",
        ktp_no: "",
        ktp_path: "",
        selfie_ktp_path: "",
        sim_no: "",
        type: "",
        sim_path: "",
        selfie_sim_path: "",
        expired_at: "",
        password: "",
      },
      vaccines: [],
      genderList: [
        { text: 'Laki-laki', value: 'L' },
        { text: 'Perempuan', value: 'P' },
      ],
      simTypeList: [
        { text: 'A', value: 'A' },
        { text: 'B1', value: 'B1' },
        { text: 'B2', value: 'B2' },
      ],
      vaccineTypeList: [
        { text: 'Vaksin 1', value: 'Vaksin 1' },
        { text: 'Vaksin 2', value: 'Vaksin 2' },
        { text: 'Booster', value: 'Booster' },
      ],
      error: {
        ktp: false,
        ktp_selfie: false,
        sim: false,
        sim_selfie: false,
        vaccines: false
      },
      isSubmitDriverError: false,
      errorMessage: null,
      isSubmitDriverSuccess: false,
      successMessage: null,
    };
  },
  validations: {
    form: {
      name: { required },
      email: { required, email },
      phone: { required, minLength: minLength(8), maxLength: maxLength(15) },
      address: { required },
      dob: { required },
      gender: { required },
      ktp_no: { required, minLength: minLength(16), maxLength: maxLength(16) },
      sim_no: { required, minLength: minLength(12), maxLength: maxLength(12) },
      type: { required },
      expired_at: { required },
      password: {
        required,
        minLength: minLength(8),
        strength: function(value) {
          const containsUppercase = /[A-Z]/.test(value)
          const containsLowercase = /[a-z]/.test(value)
          const containsNumber = /[0-9]/.test(value)
          const containsSpecial = /[#?!@$%^&*-]/.test(value)
          return containsUppercase && containsLowercase && containsNumber && containsSpecial
        }
      },
    },
    vaccines: {
      $each: {
        dosage: { required },
        vaccine_no: { required },
      }
    }
  },
  methods: {
    submitDriver() {
      if (this.form.ktp_path === "") {
        this.error.ktp = true;
      } 
      if (this.form.selfie_ktp_path === "") {
        this.error.ktp_selfie = true;
      } 
      if (this.form.sim_path === "") {
        this.error.sim = true;
      } 
      if (this.form.selfie_sim_path === "") {
        this.error.sim_selfie = true;
      } 

      for (let index = 0; index < this.vaccines.length; index++) {
        const element = this.vaccines[index];
        if (element.vaccine_path === "") {
          this.error.vaccines = true
          this.vaccines[index].error = true;
          index = this.vaccines.length
        } else {
          this.error.vaccines = false
        }
      }

      this.$v.$touch();

      if (!this.$v.$invalid && !this.error.ktp && !this.error.ktp_selfie && !this.error.sim && !this.error.sim_selfie && !this.error.vaccines) {
        const payload = {
          ...this.form,
          vaccines: this.vaccines.map((item) => {
            return {
              vaccine_no: item.vaccine_no,
              vaccine_path: item.vaccine_path,
              dosage: item.dosage
            }
          })
        }
        window.scrollTo(0,0);
        this.$axios.post('/v1/logistic_company/driver', payload)
          .then(response => {
            this.isSubmitDriverSuccess = true
            this.isSubmitDriverError = false
            this.successMessage = response.data.message
            setTimeout(() => {
              this.$router.push('/driver')
            }, 5000)
          }).catch(error => {
            this.isSubmitDriverSuccess = false
            this.isSubmitDriverError = true
            this.errorMessage = error.response.data.message
          })
      }
    },
    uploadVaccine(index) {
      document.getElementById(`upload_certificate_${index}`).click();
    },
    tambahVaccine() {
      this.vaccines.push({
        error: false,
        dosage: "",
        vaccine_no: "",
        vaccine_path: "",
      })
    },
    hapusVaksin(index) {
      this.vaccines.splice(index, 1);
    },
    uploadDocument(event) {
      if(event.target.files[0] !== undefined){
        let extension = event.target.files[0].name.split(".").pop()
        let allowedExtention = ['jpg','jpeg','png','pdf']
        if(allowedExtention.includes(extension.toLowerCase())){
          let param = new FormData();
          param.append('file', event.target.files[0])
          param.append('status', 'active') 
          param.append('title', event.target.name)
          param.append('description', 'driver')

          this.$axios.post('/v1/admin/media', param)
            .then(response => {
              if (event.target.name === 'upload_ktp') {
                this.form.ktp_path = response.data.data.file
                this.error.ktp = false
              } else if (event.target.name === 'upload_ktp_selfie') {
                this.form.selfie_ktp_path = response.data.data.file
                this.error.ktp_selfie = false
              } else if (event.target.name === 'upload_sim') {
                this.form.sim_path = response.data.data.file
                this.error.sim = false
              } else if (event.target.name === 'upload_sim_selfie') {
                this.form.selfie_sim_path = response.data.data.file
                this.error.sim_selfie = false
              } else {
                const indexInput = event.target.name.split('_').pop()
                const vaccines = this.vaccines
                for (let index = 0; index < vaccines.length; index++) {
                  if (index == indexInput) {
                    this.vaccines[index].error = false
                    this.vaccines[index].vaccine_path = response.data.data.file
                  }
                }
              }
            })

        }else{
          this.isSubmitDriverError = true
          this.errorMessage = "image extentions not allowed"
        }
      }
    },
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <b-form @submit.prevent="submitDriver" class="form-horizontal">
          <div class="card">
            <div class="card-body">
              <b-alert
                v-model="isSubmitDriverSuccess"
                class="mt-3"
                variant="success"
                dismissible
              >{{ successMessage }}</b-alert>

              <b-alert
                v-model="isSubmitDriverError"
                class="mt-3"
                variant="danger"
                dismissible
              >{{errorMessage}}</b-alert>
              <div class="row">
                <div class="col-lg-4">
                  <b-form-group id="name-group" :label="$t('form.field.name')" label-for="name">
                    <b-form-input
                      id="name"
                      name="name"
                      v-model.trim="form.name"
                      :class="{ 'is-invalid': $v.form.name.$error }"
                      type="text"
                    ></b-form-input>
                    <div v-if="$v.form.name.$error" class="invalid-feedback">
                      <span v-if="!$v.form.name.required">{{ $t('form.validation.required', { field: $t('form.field.name') }) }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group id="email-group" label="Email" label-for="email">
                    <b-form-input
                      id="email"
                      name="email"
                      v-model.trim="form.email"
                      type="text"
                      :class="{ 'is-invalid': $v.form.email.$error }"
                    ></b-form-input>
                    <div v-if="$v.form.email.$error" class="invalid-feedback">
                      <span v-if="!$v.form.email.required">{{ $t('form.validation.required', { field: 'Email' }) }}</span>
                      <span v-if="!$v.form.email.email">{{ $t('form.validation.email', { field: 'Email' }) }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group id="phone-group" label="Telepon" label-for="telepone">
                    <b-form-input
                      id="phone"
                      name="phone"
                      v-model.trim="form.phone"
                      type="text"
                      @keypress="enterNumbers"
                      :class="{ 'is-invalid': $v.form.phone.$error }"
                    ></b-form-input>
                    <div v-if="$v.form.phone.$error" class="invalid-feedback">
                      <span v-if="!$v.form.phone.required">{{ $t('form.validation.required', { field: $t('form.field.phone') }) }}</span>
                      <span v-if="!$v.form.phone.minLength">{{ $t('form.validation.min_length', { field: $t('form.field.phone'), length: 8 }) }}</span>
                      <span v-if="!$v.form.phone.maxLength">{{ $t('form.validation.max_length', { field: $t('form.field.phone'), length: 15 }) }}</span>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-lg-4">
                  <b-form-group id="address-group" :label="$t('form.field.address')" label-for="address">
                    <b-textarea
                      id="address"
                      name="address"
                      v-model.trim="form.address"
                      :class="{ 'is-invalid': $v.form.address.$error }"
                      rows="5"
                    ></b-textarea>
                    <div v-if="$v.form.address.$error" class="invalid-feedback">
                      <span v-if="!$v.form.address.required">{{ $t('form.validation.required', { field: $t('form.field.address') }) }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group id="dob-group" label="Tanggal lahir" label-for="dob">
                    <date-picker
                      id="dob"
                      name="dob"
                      v-model.trim="form.dob"
                      :class="{ 'is-invalid': $v.form.dob.$error }"
                      :first-day-of-week="1"
                      :disabled-date="disabledAfterToday"
                      format="MM/DD/YYYY"
                      lang="en"
                    ></date-picker>
                    <div v-if="$v.form.dob.$error" class="invalid-feedback">
                      <span v-if="!$v.form.dob.required">{{ $t('form.validation.required', { field: 'Tangal Lahir' }) }}</span>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-lg-4">
                  <b-form-group id="password-group" label="Password" label-for="password">
                    <b-form-input
                      id="password"
                      name="password"
                      v-model.trim="form.password"
                      :class="{ 'is-invalid': $v.form.password.$error }"
                      type="password"
                    ></b-form-input>
                    <div v-if="$v.form.password.$error" class="invalid-feedback">
                      <span v-if="!$v.form.password.required">{{ $t('form.validation.required', { field: 'Password' }) }}</span>
                      <span v-if="!$v.form.password.minLength">{{ $t('form.validation.min_length', { field: 'Password', length: 8 }) }}</span>
                      <span v-if="!$v.form.password.strength">{{ $t('form.validation.password_strength') }}</span>
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4">
                  <h5 class="font-weight-semibold">Data KTP</h5>
                  <div class="row">
                    <div class="col-lg-6">
                      <b-button variant="outline-danger" type="button" class="w-100 mr-1 mb-1 is-invalid" @click.prevent="$refs.updateKtp.click()">Upload KTP</b-button>
                      <div v-if="error.ktp" class="invalid-feedback">
                        <span>{{ $t('form.validation.required', { field: 'KTP' }) }}</span>
                      </div>
                      <img v-if="form.ktp_path" :src="form.ktp_path" alt="200x200" class="img-thumbnail w-100" />
                      <input type="file" name="upload_ktp" ref="updateKtp" @change="uploadDocument" />
                    </div>
                    <div class="col-lg-6">
                      <b-button variant="outline-danger" type="button" class="w-100 ml-1 mb-1 is-invalid" @click.prevent="$refs.updateKtpSelfie.click()">Upload Selfie KTP</b-button>
                      <div v-if="error.ktp_selfie" class="invalid-feedback">
                        <span>{{ $t('form.validation.required', { field: 'Selfie KTP' }) }}</span>
                      </div>
                      <img v-if="form.selfie_ktp_path" :src="form.selfie_ktp_path" alt="200x200" class="img-thumbnail w-100" />
                      <input type="file" name="upload_ktp_selfie" ref="updateKtpSelfie" @change="uploadDocument" />
                    </div>
                  </div>

                  <b-form-group id="ktp-group" label="No KTP" label-for="ktp">
                    <b-form-input
                      id="ktp"
                      name="ktp"
                      v-model.trim="form.ktp_no"
                      :class="{ 'is-invalid': $v.form.ktp_no.$error }"
                      type="text"
                    ></b-form-input>
                    <div v-if="$v.form.ktp_no.$error" class="invalid-feedback">
                      <span v-if="!$v.form.ktp_no.required">{{ $t('form.validation.required', { field: 'No KTP' }) }}</span>
                      <span v-if="!$v.form.ktp_no.minLength">{{ $t('form.validation.digit', { field: 'No KTP', length: 16 }) }}</span>
                      <span v-if="!$v.form.ktp_no.maxLength">{{ $t('form.validation.digit', { field: 'No KTP', length: 16 }) }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group label="Jenis Kelamin" v-slot="{ ariaDescribedby }">
                    <b-form-radio-group
                      id="gender"
                      v-model="form.gender"
                      :options="genderList"
                      :class="{ 'is-invalid': $v.form.gender.$error }"
                      :aria-describedby="ariaDescribedby"
                      name="gender"
                    ></b-form-radio-group>
                    <div v-if="$v.form.gender.$error" class="invalid-feedback">
                      <span v-if="!$v.form.gender.required">{{ $t('form.validation.required', { field: 'Jenis Kelamin' }) }}</span>
                    </div>
                  </b-form-group>

                </div>
                <div class="col-lg-4 border-kiri">
                  <h5 class="font-weight-semibold">Data SIM</h5>
                  <div class="row">
                    <div class="col-lg-6">
                      <b-button variant="outline-danger" type="button" class="w-100 mr-1 mb-1 is-invalid" @click.prevent="$refs.updateSim.click()">Upload SIM</b-button>
                      <div v-if="error.sim" class="invalid-feedback">
                        <span>{{ $t('form.validation.required', { field: 'SIM' }) }}</span>
                      </div>
                      <img v-if="form.sim_path" :src="form.sim_path" alt="200x200" class="img-thumbnail w-100" />
                      <input type="file" class="invalid-feedback" name="upload_sim" ref="updateSim" @change="uploadDocument" />
                    </div>
                    <div class="col-lg-6">
                      <b-button variant="outline-danger" type="button" class="w-100 ml-1 mb-1 is-invalid" @click.prevent="$refs.updateSimSelfie.click()">Upload Selfie SIM</b-button>
                      <div v-if="error.sim_selfie" class="invalid-feedback">
                        <span>{{ $t('form.validation.required', { field: 'Selfi SIM' }) }}</span>
                      </div>
                      <img v-if="form.selfie_sim_path" :src="form.selfie_sim_path" alt="200x200" class="img-thumbnail w-100" />
                      <input type="file" class="invalid-feedback" name="upload_sim_selfie" ref="updateSimSelfie" @change="uploadDocument" />
                    </div>
                  </div>

                  <b-form-group id="sim-group" label="No SIM" label-for="sim">
                    <b-form-input
                      id="sim"
                      name="sim"
                      v-model.trim="form.sim_no"
                      :class="{ 'is-invalid': $v.form.sim_no.$error }"
                      type="text"
                    ></b-form-input>
                    <div v-if="$v.form.sim_no.$error" class="invalid-feedback">
                      <span v-if="!$v.form.sim_no.required">{{ $t('form.validation.required', { field: 'No SIM' }) }}</span>
                      <span v-if="!$v.form.sim_no.minLength">{{ $t('form.validation.digit', { field: 'No SIM', length: 12 }) }}</span>
                      <span v-if="!$v.form.sim_no.maxLength">{{ $t('form.validation.digit', { field: 'No SIM', length: 12 }) }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group id="jenisSim-group" label="Jenis SIM" label-for="jenisSim">
                    <b-form-select
                      id="jenisSim"
                      name="jenisSim"
                      v-model.trim="form.type"
                      :options="simTypeList"
                      :class="{ 'is-invalid': $v.form.type.$error }"
                    ></b-form-select>
                    <div v-if="$v.form.type.$error" class="invalid-feedback">
                      <span v-if="!$v.form.type.required">{{ $t('form.validation.required', { field: 'Jenis SIM' }) }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group id="masaActiveSim-group" label="Masa Aktif SIM" label-for="masaActiveSim">
                    <date-picker
                      id="expired_at"
                      name="expired_at"
                      v-model.trim="form.expired_at"
                      :class="{ 'is-invalid': $v.form.expired_at.$error }"
                      :disabled-date="notBeforeToday"
                      :first-day-of-week="1"
                      format="DD MMMM YYYY"
                      value-type="YYYY-MM-DD"
                      lang="en"
                    ></date-picker>
                    <div v-if="$v.form.expired_at.$error" class="invalid-feedback">
                      <span v-if="!$v.form.expired_at.required">{{ $t('form.validation.required', { field: 'Masa Aktif SIM' }) }}</span>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-lg-4 border-kiri">
                  <h5 class="font-weight-semibold">Data Vaksin</h5>
                  <div class="row border-radius m-1" v-for="(item, index) in vaccines" :key="index">
                    <div class="col-lg-12">
                      <b-button variant="outline-danger" type="button" class="w-100 mt-3 is-invalid" @click="uploadVaccine(index)">Upload Sertifikat</b-button>
                      <div v-if="item.error" class="invalid-feedback">
                        <span>{{ $t('form.validation.required', { field: 'Vaksin' }) }}</span>
                      </div>
                      <img v-if="item.vaccine_path" :src="item.vaccine_path" alt="200x200" class="img-thumbnail w-100 mb-3" />
                      <input type="file" :name="`upload_certificate_${index}`" :id="`upload_certificate_${index}`" :ref="`updateCertificates_${index}`" @change="uploadDocument" />
                    </div>
                    <div class="col-lg-5">
                      <b-form-group :id="`dosage-group-${index}`" label="Dosis" label-for="dosage">
                        <b-form-select
                          :id="`dosage-${index}`"
                          :name="`dosage-${index}`"
                          v-model.trim="item.dosage"
                          :options="vaccineTypeList"
                          :class="{ 'is-invalid': $v.vaccines.$each[index].dosage.$error }"
                        ></b-form-select>
                        <div v-if="$v.vaccines.$each[index].dosage.$error" class="invalid-feedback">
                          <span v-if="!$v.vaccines.$each[index].dosage.required">{{ $t('form.validation.required', { field: 'Dosis' }) }}</span>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-lg-7">
                      <b-form-group id="noSertifikat-group" label="No Sertifikat" label-for="noSertifikat">
                        <b-form-input
                          id="noSertifikat"
                          v-model.trim="item.vaccine_no"
                          :class="{ 'is-invalid': $v.vaccines.$each[index].vaccine_no.$error }"
                          type="text"
                        ></b-form-input>
                        <div v-if="$v.vaccines.$each[index].vaccine_no.$error" class="invalid-feedback">
                          <span v-if="!$v.vaccines.$each[index].vaccine_no.required">{{ $t('form.validation.required', { field: 'No Sertifikat' }) }}</span>
                        </div>
                      </b-form-group>
                    </div>
                    <b-button variant="outline-danger" type="button" class="w-100 m-1"  @click="hapusVaksin(index)">Hapus</b-button>
                  </div>
                  <b-button variant="outline-danger" type="button" class="w-100 mt-3" @click="tambahVaccine">Tambah Sertifikat</b-button>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-sm-2">
                  <b-button to="/driver" type="button" class="w-100 btn-light">Kembali</b-button>
                </div>
                <div class="col-sm-2">
                  <b-button type="submit" variant="danger" class="w-100">Simpan</b-button>
                </div>
              </div>
            </div>
          </div>
        </b-form>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
input[type=file] {
  visibility: hidden;
}
</style>
